const months: string[] = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

export const getMonth = (number: number) => {
  return months[number - 1];
};

const getDate = (date: Date) => {
  const currDate = `${
    months[date.getMonth() + 1 - 1]
  } ${date.getDate()}, ${date.getFullYear()}`;

  const currTime = `${date.getHours()}:${date.getMinutes()} ${
    date.getHours() >= 12 ? "PM" : "AM"
  }`;
  const dateTime = `${date.getDate()} + ${
    months[date.getMonth() + 1 - 1]
  } + ${date.getFullYear()}`;

  return [currDate, currTime, dateTime];
};
export default getDate;
